import store from '@/store';
import { FETCH_CATEGORIES } from '@/store/actions/category.actions';

export const CategoriesLoaded = (to, from, next) => {
  const categories = store.getters.categories;

  if (!categories.length) {
    return store.dispatch(FETCH_CATEGORIES)
      .then(() => next())
      .catch(() => next({name: 'error'}));
  }

  return next();
};